export const getIsKeyStrokeValid = (value: string): boolean => {
  const forwardSlashCount = (value.match(/\//g) || []).length
  const re = /^[a-zA-Z0-9/)(+=._-]*$/
  const isValid = re.test(value) && forwardSlashCount <= 1
  return isValid
}
